import { SET_USER_APPS } from "../../actions/DashboardDesigner/actionContants";

const userAppsInfo = (state = [], action) => {
	switch (action.type) {
		case SET_USER_APPS:
			return action.userAppsInfo;
		default:
			return state;
	}
};

export default userAppsInfo;
